import React from 'react'
import ApiClient from '../helpers/ApiClient';
import axios from 'axios';


export const addAlumniRegData = async ({ name,
     permanent_address, correspondence_address, mobile_no, 
    resident_no, 
    personal_email, 
    office_email, 
    nic_passport_no,
    designation, 
    official_address, 
    sab_academic_qualifications, 
    year_of_enrollment, 
    sab_reg_no,
      intake, 
    year_of_degree_obtained
}) => {
    try {
        const response = await ApiClient.post(``,
            {

                name, permanent_address, correspondence_address, mobile_no, 
                resident_no, 
                personal_email, 
                office_email, 
                nic_passport_no,
                designation, 
                official_address, 
                sab_academic_qualifications, 
                year_of_enrollment, 
                sab_reg_no,
                  intake, 
                year_of_degree_obtained
           
            },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


// controller
export const getAlumniRegData = async (queryParams) => {
    try {
        const response = await ApiClient.get(`/AlumniPage/getAlumniRegistrations${queryParams}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateApprovalStatus = async (id, { approvalStatus }) => {
    try {
        const response = await ApiClient.put(`/AlumniPage/alumniRegistrationApproval/${id}`, { approvalStatus });
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateAlumniRegistration = async (id, updateData) => {
    try {
      const response = await ApiClient.patch(`/AlumniPage/updateAlumniRegistration/${id}`, updateData);
      return response;
    } catch (error) {
      throw error;
    }
  };